export const SubscriptionCartWhatHappensNext = () => {
  return (
    <p className="text-center text-content-secondary">
      Your recommended products may be changed or updated anytime based on your feedback or EO
      clinical team recommendations.
    </p>
  );
};
